import { Button, css, Stack } from 'canoe';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import styled from 'canoe/lib/styled';
import { TOOLTIP_PLACEMENTS_CUSTOMIZATION } from 'craft/containers/Toolbox/tabs/Placements/TooltipPlacements/TooltipPlacementsCustomization';
import { InteractivePlacementPicker } from 'craft/containers/Toolbox/tabs/Placements/components/InteractivePlacementPicker';
import { StepSubtitle, StepTitle } from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { setForcePlacementsTab, setPlacementMode } from 'craft/state';
import { TooltipType } from 'craft/types/TooltipType';

interface InteractivePlacementPickerProps {
  contentType: TooltipType;
  initialValue: string | undefined;
  handleConfirmPlacement: (value: string) => void;
  handleSkip: () => void;
  skipShouldExit: boolean;
}

const StepOneContainer = styled.div`
  ${({ theme }) => css`
    margin: ${theme.spaces.xs};
  `}
`;

export const StepOne = ({
  initialValue,
  handleConfirmPlacement,
  handleSkip,
  skipShouldExit,
  contentType,
}: InteractivePlacementPickerProps) => {
  // enforce editor placement mode here
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setForcePlacementsTab(true));
    dispatch(setPlacementMode(true));
    return () => {
      dispatch(setForcePlacementsTab(false));
      dispatch(setPlacementMode(false));
    };
  }, []);

  return (
    <StepOneContainer>
      <Stack justify="center" space="xs">
        <StepTitle size="short" active>
          {TOOLTIP_PLACEMENTS_CUSTOMIZATION[contentType].title}
        </StepTitle>
        <StepSubtitle>use your mouse to choose a place.</StepSubtitle>
      </Stack>
      <InteractivePlacementPicker
        initialValue={initialValue}
        handleConfirmPlacement={handleConfirmPlacement}
      />
      <Button variant="neutral" appearance="outline" fullWidth onClick={handleSkip}>
        {skipShouldExit ? 'Cancel' : 'Enter Manually'}
      </Button>
    </StepOneContainer>
  );
};
